import { render, staticRenderFns } from "./my_attention.vue?vue&type=template&id=46374003&"
import script from "./my_attention.vue?vue&type=script&lang=js&"
export * from "./my_attention.vue?vue&type=script&lang=js&"
import style0 from "./my_attention.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports